import React from 'react';
import {Paper} from '@material-ui/core';
import moment from 'moment';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
require('highcharts/modules/exporting')(Highcharts);
const FileOpsProgressChart = ({fleetActivityCount}) => {
  const customToolTip = (points) => {
    let tlTip = `<p>Date: ${moment(points[0].x).format('MMM YYYY')}</p><br/>`;
    points.map(point => {
      tlTip += '<b>'+point.series.name+'</b>:'+point.y+'</p><br/>';
    });
    return tlTip
  }
  const getTimePlot = (data) => {
    return data.map((item) => {return [new Date(item[0]).getTime(), item[1]]})
  }
  const options = {
    chart: {
      type: 'line',
      zoomType: 'x'
    },
    title: {
        text: ''
    },
    xAxis: {
      type: 'datetime'
    },
    yAxis:{
      allowDecimals: false,
      title: {
        text: 'File(s) Count',
        style: {
          fontSize: '11px'
        }
      },
      labels: {
        formatter: function () {
          return this.value;
        }
      },
      gridLineDashStyle: 'longdash'
    },
    tooltip: {
      formatter: function(){
        return customToolTip(this.points);
      },
      shared: true
    },
    credits: {
      enabled: false
    },
    series: [
      {
        name: 'Rejected',
        data: getTimePlot(fleetActivityCount.plots.rejected)
      },
      {
        name: 'To be Renamed',
        data: getTimePlot(fleetActivityCount.plots.rename)
      },
      {
        name: 'OCR Rejected',
        data: getTimePlot(fleetActivityCount.plots.issue)
      },
      {
        name: 'Upload',
        data: getTimePlot(fleetActivityCount.plots.uploaded)
      },
      {
        name: 'Published',
        data: getTimePlot(fleetActivityCount.plots.published)
      },
      // {
      //   name: 'OCRed',
      //   data: getTimePlot(fleetActivityCount.plots.completed)
      // }
    ]
  };
  return(
    <Paper style={{clear:'both'}}>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
      />
    </Paper>
  )
}
export default FileOpsProgressChart;
